import './App.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { getMyProfile, setToken } from 'containers/Auth/store/actions';

import { isAuthPage } from 'utils/utils';
import { LOCALSTORAGE } from 'utils/constants';
import LoadingCircle from 'components/LoadingCircle';
import MainHeader from 'components/MainHeader';

class App extends React.Component {

    componentWillMount() {
        let token = localStorage.getItem(LOCALSTORAGE.ID_TOKEN);

        if(token != null && this.props.routing.locationBeforeTransitions.pathname !== '/logout') {
            this.props.setToken(token);
            this.props.getMyProfile(token)
                .then((res) => {
                    if(res.code === 200) {
                        if(['/', '/login'].indexOf(this.props.routing.locationBeforeTransitions.pathname) !== -1) {
                            this.props.changeLocation('/users');
                        }
                    } else {
                        this.props.changeLocation('/logout');
                    }
                })
        } else if(isAuthPage(this.props.routing.locationBeforeTransitions.pathname) === false) {
            this.props.changeLocation('/login');
        }
    }

    render() {
        let thisIsAnAuthPage = isAuthPage(this.props.routing.locationBeforeTransitions.pathname);
        if(this.props.auth.isFetching === true) {
            return (
                <div className="wrapper">
                    {thisIsAnAuthPage === false ? <MainHeader /> : null}

                    <LoadingCircle className="c-loading-circle--profile" />
                </div>
            )
        } else {
            return (
                <div className="wrapper">
                    {thisIsAnAuthPage === false ? <MainHeader /> : null}

                    {this.props.children}
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        routing: state.routing
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getMyProfile: (token) => dispatch(getMyProfile(token)),
        setToken: (token) => dispatch(setToken(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js